import { Link, useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import NFTs from "../_metadata.json";
import abi from "../abi.json";
import abi2 from "../abi2.json";

import Web3 from "web3";
import hensjs from "hensjs";
const { ethereum } = window;
const web3 = new Web3(ethereum);
const address = "0xFAc96E4e3201e6928C1a2d3E8bd6B8d5072C7648";
const address2 = "0xFDEf6e24E560fAc0A8705Ad51F9B55F1FC10cB91";
const chainID = 1;

function Nfts() {
  const [currentPost, setCurrentPost] = useState([]);
  const [count, setCount] = useState(48);
  const [token, setToken] = useState("");
  const [rarity, setRarity] = useState("");

  let navigate = useNavigate();

  useEffect(async () => {
    setCurrentPost(NFTs.slice(0, count));
  }, []);

  const tokenExists = (edition) => {
    return NFTs.some(function (el) {
      return el.edition === parseInt(edition);
    });
  };

  const more = () => {
    const newCount = count + 48;
    setCurrentPost(NFTs.slice(0, count));
    setCount(newCount);
  };

  const lowetTokend = () => {
    const list = NFTs.sort((a, b) => b.edition - a.edition);
    const currentPosts = list.slice(0, 48);
    setCurrentPost(currentPosts);
    setCount(48);
  };

  const HighestTokend = () => {
    const list = NFTs.sort((a, b) => a.edition - b.edition);
    const currentPosts = list.slice(0, 48);
    setCurrentPost(currentPosts);
    setCount(48);
  };

  const lowetRarity = () => {
    const list = NFTs.sort((a, b) => a.Rarity - b.Rarity);
    const currentPosts = list.slice(0, 48);
    setCurrentPost(currentPosts);
    setCount(48);
  };

  const HighRarity = () => {
    const list = NFTs.sort((a, b) => b.Rarity - a.Rarity);
    const currentPosts = list.slice(0, 48);
    setCurrentPost(currentPosts);
    setCount(48);
  };

  const Filter = (value, type) => {
    console.log(value, type);
    // let obj = NFTs.find((o) => o.attributes[type - 1]["value"] === value);
    let obj = NFTs.filter((o) =>
      o.attributes[type - 1]["value"].includes(value)
    );
    console.log(obj);
    setCurrentPost(obj);
    setCount(48);
  };

  const getOwner = async (e, id) => {
    if (window.ethereum) {
      const contract = new web3.eth.Contract(abi, address);
      const contract2 = new web3.eth.Contract(abi2, address2);

      await web3.eth.net.getId().then(async (netId) => {
        if (netId != chainID) {
        } else {
          try {
            const address = await contract.methods.ownerOf(id).call();
            console.log(address);
            const domain = await hensjs.getNameOfOwner(address);
            console.log(domain);
            // const owner =
            //   String(token).substring(0, 6) +
            //   "..." +
            //   String(token).substring(38);
            e.target.innerHTML = `<a>${domain}</a>`;
          } catch (error) {
            try {
              const token = await contract2.methods.ownerOf(id).call();
              const owner =
                String(token).substring(0, 6) +
                "..." +
                String(token).substring(38);
              e.target.innerHTML = "Owner : " + owner;
            } catch (error) {
              e.target.innerHTML = "NFT not Minted Yet";
            }
            // e.target.innerHTML = "NFT not Minted Yet";
          }
        }
      });
    } else {
      return {
        address: "",
        status: (
          <span>
            <p>
              {" "}
              🦊{" "}
              <a
                target="_blank"
                rel="noreferrer"
                href={`https://metamask.io/download.html`}
              >
                You must install Metamask, a virtual Ethereum wallet, in your
                browser.
              </a>
            </p>
          </span>
        ),
      };
    }
  };

  const getDetails = () => {
    // console.log(token);
    if (token !== "") {
      if (tokenExists(token) === true) {
        navigate(`/details/${token}`);
      }
    }
  };

  const getRarity = () => {
    if (rarity !== "") {
      const data = NFTs.find((o) => o.Rarity_Score === parseInt(rarity));
      const token = data.edition;
      if (tokenExists(token) === true) {
        navigate(`/details/${token}`);
      }
    }
  };

  return (
    <section
      className="container project_container"
      id="nftproject"
      style={{
        marginTop: "11rem",
      }}
    >
      <h2>All MonkeyDoo's</h2>

      <div className="sort">
        <span className="sort_item active" onClick={() => HighestTokend()}>
          All
        </span>
        <span
          className="sort_item"
          data-sort="a"
          onClick={() => HighestTokend()}
        >
          Lowest Token Id
        </span>
        <span className="sort_item" data-sort="b" onClick={() => lowetTokend()}>
          Highest Token Id
        </span>
        <span className="sort_item" data-sort="c" onClick={() => lowetRarity()}>
          Low Rarity
        </span>
        <span className="sort_item" data-sort="d" onClick={() => HighRarity()}>
          Top Rarity
        </span>
      </div>

      <div>
        <input
          style={{
            width: "250px",
            border: "1px solid #ed7299",
            background: "inherit",
            padding: "13px",
            marginRight: "10px",
          }}
          placeholder="Search By Token ID"
          type="number"
          onChange={(e) => setToken(e.target.value)}
        />
        <button className="btn btn-primary" onClick={() => getDetails()}>
          Search
        </button>
        <br />
        <input
          style={{
            width: "250px",
            border: "1px solid #ed7299",
            background: "inherit",
            padding: "13px",
            marginRight: "10px",
          }}
          placeholder="Search By Rarity"
          type="number"
          onChange={(e) => setRarity(e.target.value)}
        />
        <button className="btn btn-primary" onClick={() => getRarity()}>
          Search
        </button>
      </div>
      <div></div>
      <div className="filter">
        <select onChange={(e) => Filter(e.target.value, 1)}>
          <option selected disabled>
            Filter By Background
          </option>
          <option value="Bananas">Bananas (119)</option>
          <option value="Blue and Pink">Blue and Pink (518)</option>
          <option value="Blue">Blue (1007)</option>
          <option v alue="Clouds">
            Clouds (56)
          </option>
          <option value="Ethereum Classic">Ethereum Classic (200)</option>
          <option value="Gold">Gold (25)</option>
          <option value="Green and Purple">Green and Purple (494)</option>
          <option value="Jungle Green Yellow">Jungle Green Yellow (117)</option>
          <option value="Pink">Pink (1004)</option>
          <option value="Purple">Purple (972)</option>
          <option value="Rainbow">Rainbow (18)</option>
        </select>
        <select onChange={(e) => Filter(e.target.value, 2)}>
          <option selected disabled>
            Filter By Base
          </option>
          <option value="Black">Black (505)</option>
          <option value="Blue">Blue (698)</option>
          <option value="Bronze">Bronze (107)</option>
          <option value="Brown">Brown (662)</option>
          <option value="Dia de Muertos">Dia de Muertos (4)</option>
          <option value="Gaudi">Gaudi (6)</option>
          <option value="Gold">Gold (24)</option>
          <option value="Green">Green (496)</option>
          <option value="Rainbow Dark">Rainbow Dark (11)</option>
          <option value="Rainbow Light">Rainbow Light (11)</option>
          <option value="Silver">Silver (60)</option>
          <option value="Tiger">Tiger (209)</option>
          <option value="Zebra">Zebra (207)</option>
        </select>
        <select onChange={(e) => Filter(e.target.value, 3)}>
          <option selected disabled>
            Filter By Clothing
          </option>
          <option value="Bow Tie Blue">Bow Tie Blue (262)</option>
          <option value="Bow Tie Red">Bow Tie Red (97)</option>
          <option value="NoClothing">NoClothing (2641)</option>
        </select>
        <select onChange={(e) => Filter(e.target.value, 4)}>
          <option selected disabled>
            Filter By Earrings
          </option>
          <option value="Diamond">Diamond (18)</option>
          <option vlaue="ETC">ETC (111)</option>
          <option vlaue="NoEarrings">NoEarrings (2816)</option>
          <option value="Stud Gold">Stud Gold (55)</option>
        </select>
        <select onChange={(e) => Filter(e.target.value, 5)}>
          <option selected disabled>
            Filter By Mouth
          </option>
          <option value="Amazed">Amazed (683)</option>
          <option value="Happy">Happy (480)</option>
          <option value="Rainbow">Rainbow (51)</option>
          <option valeu="Scared">Scared (391)</option>
          <option value="Shouting 2 Golden Teeths">
            Shouting 2 Golden Teeths (93)
          </option>
          <option value="Shouting Golden Teeths">
            Shouting Golden Teeths (52)
          </option>
          <option value="Shouting">Shouting (575)</option>
          <option value="Surprised">Surprised (408)</option>
        </select>
        <select onChange={(e) => Filter(e.target.value, 6)}>
          <option selected disabled>
            Filter By Eyes
          </option>
          <option value="3Dglasses">3Dglasses (61)</option>
          <option value="Angry Blue">Angry Blue (156)</option>
          <option value="Angry Brown">Angry Brown (275)</option>
          <option value="Angry Gold">Angry Gold (19)</option>
          <option value="Angry Gaudi">Angry Gaudi (13)</option>
          <option valeu="Angry Green">Angry Green (186)</option>
          <option value="Angry Grey">Angry Grey (271)</option>
          <option value="Aviator Sunglasses Black">
            Aviator Sunglasses Black (72)
          </option>
          <option value="Aviator Sunglasses Brown">
            Aviator Sunglasses Brown (133)
          </option>
          <option value="Casual Brown">Casual Brown (99)</option>
          <option value="Crying">Crying (94)</option>
          <option value="Cute Blue">Cute Blue (148)</option>
          <option value="Cute Brown">Cute Brown (283)</option>
          <option value="Cute Gold">Cute Gold (11)</option>
          <option value="Cute Green">Cute Green (221)</option>
          <option value="Cute Grey">Cute Grey (257)</option>
          <option value="Innocent Brown">Innocent Brown (191)</option>
          <option value="Innocent Gold">Innocent Gold (16)</option>
          <option value="Laser Beam">Laser Beam (27)</option>
          <option value="Laser Eyes">Laser Eyes (22)</option>
          <option value="Lazy Brown">Lazy Brown (99)</option>
          <option value="Nerdy Glasses1">Nerdy Glasses1 (49)</option>
          <option value="Nerdy Glasses2">Nerdy Glasses2 (76)</option>
          <option value="Nerdy Glasses3">Nerdy Glasses3 (130)</option>
          <option value="Not Amused Brown">Not Amused Brown (91)</option>
        </select>
        <select onChange={(e) => Filter(e.target.value, 7)}>
          <option selected disabled>
            Filter By Hat
          </option>
          <option value="Captain">Captain (236)</option>
          <option value="Chef">Chef (207)</option>
          <option value="ETC Crown">ETC Crown (34)</option>
          <option value="Fez">Fez (65)</option>
          <option value="Halo">Halo (300)</option>
          <option value="No Hat">No Hat (1420)</option>
          <option value="Party hat">Party hat (94)</option>
          <option value="StinkyPoop">StinkyPoop (48)</option>
          <option value="Top Hat">Top Hat (237)</option>
          <option value="Uncle Sam hat">Uncle Sam hat (98)</option>
          <option value="Unicorn">Unicorn (10)</option>
          <option value="Worm">Worm (15)</option>
          <option value="XMas hat">XMas Hat (236)</option>
        </select>
      </div>

      <div className="image_cards">
        {currentPost.map((nft, i) => (
          <article className="image_card" key={i}>
            <Link to={`/details/${nft.edition}`}>
              <img
                src={`https://monkeydoonft.online/images/${nft.edition}.png`}
                style={{
                  padding: "15px",
                }}
              />
            </Link>

            <div className="card_text">
              <h5
                style={{
                  color: "rgba(17, 36, 54, 1)",
                }}
              >
                MonkeyDoos #{nft.edition}
              </h5>
              <h3
                style={{
                  color: "rgba(17, 36, 54, 1)",
                }}
              >
                Rarity #{nft.Rarity_Score}
              </h3>
              <a
                style={{
                  color: "#111",
                  cursor: "pointer",
                }}
                onClick={(e) => getOwner(e, nft.edition)}
              >
                Click to see if Minted
              </a>
            </div>
          </article>
        ))}
      </div>
      <button className="btn btn-primary" onClick={() => more()}>
        See More{" "}
      </button>
    </section>
  );
}

export default Nfts;
